import { DragDropLayoutTabDefinition } from "@pimo/pimo-components";

/**
 * Removes columns referencing componentIds that no longer register (e.g. a card
 * hidden because its record type was hidden), reflows the remaining columns in
 * each row to fill the freed space, and drops rows left with nothing in them.
 *
 * Runs at render time only. The saved layout in the database is never rewritten,
 * so re-enabling the record type brings the old slot back untouched.
 */
export const dropStaleLayoutComponents = (
  tabs: DragDropLayoutTabDefinition[],
  staleComponentIds: ReadonlySet<string>
): DragDropLayoutTabDefinition[] => {
  if (staleComponentIds.size === 0) {
    return tabs;
  }

  return tabs.map((tab) => ({
    ...tab,
    rows: tab.rows
      .map((row) => {
        const columns = row.columns.filter(
          (column) => !staleComponentIds.has(column.componentId)
        );
        const removedCount = row.columns.length - columns.length;

        if (removedCount === 0) {
          return row;
        }

        return {
          ...row,
          columnCount: Math.max(row.columnCount - removedCount, 0),
          columns: columns.map((column, index) => ({
            ...column,
            columnIndex: index,
          })),
        };
      })
      .filter((row) => row.columnCount > 0),
  }));
};
